'use strict';

const MainNav = require('./nav/main.js');
const AweberForm = require('./forms/aweber.js');
const CommentForm = require('./forms/comment.js');
const CommentList = require('./comments/comment-list.js');

function initMainNav (ref) {
  var mainNav = new MainNav(ref);
  mainNav.bindEvents();
}

function initAweberForm (ref, consentKeeperUrl, consentKeeperApiKey) {
  var aweberForm = new AweberForm(ref);
  aweberForm.setConsentKeeper(consentKeeperUrl, consentKeeperApiKey);
  aweberForm.bindEvents();
}

function initCommentForm (ref, url, apiKey, consentKeeperUrl, consentKeeperApiKey) {
  var commentForm = new CommentForm(ref, url, apiKey);
  commentForm.setConsentKeeper(consentKeeperUrl, consentKeeperApiKey);
  commentForm.bindEvents();
}

function initCommentList (source, url, apiKey) {
  var commentList = new CommentList(source, url, apiKey);
  commentList.bindEvents();
}

module.exports = {
  initMainNav: initMainNav,
  initAweberForm: initAweberForm,
  initCommentForm: initCommentForm,
  initCommentList: initCommentList
};



//////////////////
// WEBPACK FOOTER
// ./_js/post.js
// module id = 28
// module chunks = 0